import Vue from "vue";
import VueRouter, { RouteConfig } from "vue-router";
import Home from "../views/Home.vue";
import Login from "@/views/Login.vue";

import store from "@/store";
import { Role } from "@/store/users";
import { recoverAuth } from "@/lib/auth";
import { AuthState } from "@/store/auth";

const Users = () => import("@/views/Users.vue");
const UsersList = () => import("@/components/users/list.vue");
const UsersEdit = () => import("@/components/users/edit.vue");

const Calls = () => import("@/views/calls/Calls.vue");

const Task = () => import("@/views/task/task.vue");

const RptEngine = () => import("@/views/rpt-engine/rpt-engine.vue");

const filenameFormat = () =>
  import("@/views/filename-format/filename-format.vue");
const newfileNameFormat = () =>
  import("@/components/filename-format/newFilenameFormat.vue");

const StorageCloud = () => import("@/views/cloud-storage/cloud-storage.vue");
const NewBucket = () => import("@/components/storage-cloud/newStorage.vue");

const Customers = () => import("@/views/customers/Customers.vue");
const CustomersList = () => import("@/components/customers/list.vue");
const CustomersEdit = () => import("@/components/customers/edit.vue");
const ApiKeysCustomer = () => import("@/views/customers/ApiKeys.vue");
const NewApiKeysCustomer = () => import("@/views/customers/NewApiKeys.vue");

const RequestResetPassword = () => import("@/views/ResetPassword.vue");

const NewTaskExport = () =>
  import("@/components/task-export/newTaskExport.vue");

const TagComments = () => import("@/components/tagConfigComments/index.vue");
const IPComtactConfig = () => import("@/views/config/ModuleConfiguration.vue");
const ConfigCustomer = () =>
  import("@/components/customers/configCustomer.vue");
const IPInvalid = () => import("@/components/invalid-IP/index.vue");

const Reply = () =>
  import(/* webpackChunkName: "Recordings" */ "@/views/reply/recordings.vue");

Vue.use(VueRouter);

const routes: RouteConfig[] = [
  {
    path: "/",
    name: "home",
    component: Home,
  },
  {
    path: "/login",
    name: "login",
    component: Login,
    meta: { noauth: true },
  },
  {
    path: "/requestPasswordReset",
    component: RequestResetPassword,
    meta: { noauth: true },
  },
  {
    path: "/users",
    component: Users,
    children: [
      {
        path: "",
        component: UsersList,
      },
      {
        path: "edit/:userId",
        props: true,
        component: UsersEdit,
      },
      {
        path: "new",
        component: UsersEdit,
      },
    ],
  },
  {
    path: "/calls",
    component: Calls,
    children: [
      {
        path: "",
        component: Calls,
      },
    ],
  },
  {
    path: "/recordings",
    component: Reply,
    children: [
      {
        path: "",
        component: Reply,
      },
    ],
  },
  {
    path: "/customers",
    component: Customers,
    children: [
      {
        path: "",
        component: CustomersList,
      },
      {
        path: "edit/:customerId",
        props: true,
        component: CustomersEdit,
      },
      {
        path: "new",
        component: CustomersEdit,
      },
      {
        path: "config",
        component: ConfigCustomer,
      },
    ],
  },
  {
    path: "/apikeys",
    component: ApiKeysCustomer,
  },
  {
    path: "/apikeys/new",
    component: NewApiKeysCustomer,
  },
  {
    path: "/task",
    component: Task,
  },
  {
    path: "/storagecloud",
    component: StorageCloud,
  },
  {
    path: "/storagecloud/newbucket",
    component: NewBucket,
  },
  {
    path: "/filenameformat",
    component: filenameFormat,
  },
  {
    path: "/filenameformat/newfilenameformat",
    component: newfileNameFormat,
  },
  {
    path: "/rptengine",
    component: RptEngine,
  },
  {
    path: "/task/newtaskexport",
    component: NewTaskExport,
  },
  {
    path: "/calls/tagcomments",
    component: TagComments,
  },
  {
    path: "/configuration",
    component: IPComtactConfig,
  },
  {
    path: "/ip-Invalid",
    component: IPInvalid,
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

router.beforeEach((to, from, next) => {
  if (!to.meta?.noauth) {
    checkAuth(to.meta.role).then((pass) => {
      if (pass) {
        next();
      } else {
        next({ path: "/login" });
      }
    });
  } else {
    next();
  }
});

function checkAuth(requiredRoles: Role | undefined): Promise<boolean> {
  const st = ((store.state as unknown) as { auth: AuthState }).auth;
  if (store.getters["auth/isLoggedIn"]) {
    if (!requiredRoles) {
      return Promise.resolve(true);
    }
    // eslint-disable-next-line
    return Promise.resolve(st.currentRole === requiredRoles);
  }
  return recoverAuth().then((res) => {
    if (!res) {
      return false;
    }
    store.commit("auth/SET_USER", res);
    store.commit("auth/SET_ROLES", res.user!.customerCurrent.role);
    if (!requiredRoles) {
      return true;
    }
    return res.user!.customerCurrent.role === requiredRoles;
  });
}

export default router;
